import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
 FiShoppingBag
} from "react-icons/fi";
import "./shop.css";

const API_BASE = "https://api.thetotetherapy.com";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const navigate = useNavigate();
const [toast, setToast] = useState("");
const [search, setSearch] = useState("");
  const fetchProducts = async () => {
    try {
      setLoading(true);
      setErr("");
      const res = await axios.get(`${API_BASE}/api/products`);
      setProducts(res.data);
    } catch (e) {
      setErr(e.response?.data?.message || "Failed to load products");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);
useEffect(() => {
  if (!toast) return;
  const t = setTimeout(() => setToast(""), 2000);
  return () => clearTimeout(t);
}, [toast]);
const filteredProducts = products.filter((p) =>
  (p.title || "").toLowerCase().includes(search.toLowerCase().trim())
);
  return (
    <main className="shopPage">
      {toast && (
  <div className="toast">
    {toast}
    <button className="toastClose" onClick={() => setToast("")}>✕</button>
  </div>
)}
      {/* Header */}
      <section className="shopHeader">
  <div className="shopHeader__inner">

    {/* LEFT */}
    <div className="shopHeader__left">
      <h1 className="shopTitle"> <FiShoppingBag /> Shop</h1>
      <p className="shopSubtitle">
        Thoughtfully designed totes for everyday life
      </p>
    </div>

    {/* RIGHT */}
<div className="shopHeader__right">
  <div className="shopImages">
    <div className="shopLargeImage">
      <img src="/blue1.jpeg" alt="Collection 1" />
    </div>

    <div className="shopLargeImage">
      <img src="/blue2.jpeg" alt="Collection 2" />
    </div>

    <div className="shopLargeImage">
      <img src="/blue3.jpeg" alt="Collection 3" />
    </div>
  </div>
</div>
  </div>
</section>

      {/* Content */}
      <section className="shopContent">
        <div className="shopContainer">
          <div className="shopTools">
  <div className="searchWrap">
    <span className="searchIcon">⌕</span>
    <input
      className="searchInput"
      type="text"
      placeholder="Search products by title..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  </div>

  <div className="resultCount">
    {filteredProducts.length} item(s)
  </div>
</div>
          {loading ? (
            <div className="shopState">Loading products...</div>
          ) : err ? (
            <div className="shopState error">{err}</div>
          ) : products.length === 0 ? (
            <div className="shopState">No products yet.</div>
          )  : filteredProducts.length === 0 ? (
  <div className="shopState">No products match your search.</div>
) : (
            <div className="productGrid">
{filteredProducts.map((p) => (
  <article
    className="productCard"
    key={p.id}
    onClick={() => navigate(`/product/${p.id}`)}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === "Enter") navigate(`/product/${p.id}`);
    }}
  >
    {/* Add to cart icon */}
    <button
      className="cartIconBtn"
      onClick={(e) => {
        e.stopPropagation(); // ✅ card click roko

        const existingCart = JSON.parse(localStorage.getItem("cart")) || [];
        const found = existingCart.find((item) => item.id === p.id);

        if (found) found.quantity += 1;
        else {
          existingCart.push({
            id: p.id,
            title: p.title,
            price: Number(p.price_aed),
            image: p.image_url,
            quantity: 1,
          });
        }

        localStorage.setItem("cart", JSON.stringify(existingCart));

        // ✅ popup show (toast)
        setToast(`${p.title} added to cart ✅`);
      }}
      aria-label="Add to cart"
      title="Add to cart"
      type="button"
    >
      🛒
    </button>

    <div className="productImgWrap">
      {p.image_url ? (
        <img
          src={`${API_BASE}${p.image_url}`}
          alt={p.title}
          className="productImg"
        />
      ) : (
        <div className="productImgPlaceholder">No Image</div>
      )}
    </div>

    <div className="productBody">
      <h3 className="productTitle">{p.title}</h3>

      <div className="productMeta">
        <span className="price">AED {Number(p.price_aed).toFixed(2)}</span>
        <span className="tag">Reusable</span>
      </div>

      {/* View details should ONLY navigate */}
      <button
        className="shopBtn"
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/product/${p.id}`);
        }}
        type="button"
      >
        View Details
      </button>
    </div>
  </article>
))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}